var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[(!_vm.hideNavbar)?_c('Navbar'):_vm._e(),_c('router-view'),_c('portal-target',{attrs:{"name":"modal"}}),_c('portal-target',{attrs:{"name":"overlay"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }